import React, { useEffect, useState } from 'react';
import Skeleton from 'components/Skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { deleteUserRequest, moveUserRequest, pendingUserRequest } from './pendingUsersSlice';
import { makeStyles } from '@material-ui/core/styles';
import CustomTable from 'components/CustomTable';
import { Grid } from '@material-ui/core';
import { RxCross2 } from "react-icons/rx";
import { showLoader } from 'utils';

const useStyles = makeStyles({
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  deleteModal: {
    position: 'fixed',
    height: '100vh',
    width: '100%',
    left: '0',
    top: '0',
    zIndex: '1000',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteModalChildren: {
    borderRadius: '20px',
    padding: '50px',
    height: 'max-content',
    width: 'max-content',
    maxHeight: '80vh',
    maxWidth: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    background: 'white',
    overflow: 'hidden',
  },
  deleteModalCross: {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    color: "#303a33",
    background: 'white',
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 1px, rgba(0, 0, 0, 0.23) 0px 1px 1px',
    borderBottomLeftRadius: '30px',
    '&:hover': {
      boxShadow: ' rgba(0, 0, 0, 0.16) 0px 3px 6px inset, rgba(0, 0, 0, 0.23) 0px 3px 6px inset !important',
    },
  },
  btn: {
    minWidth: '100px',
    background: '#45b77c',
    padding: '10px 20px',
    border: 'none',
    outline: 'none',
    borderRadius: '5px',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    },
  },
  backBtn: {
    minWidth: '100px',
    background: '#c6c6c6',
    padding: '10px 20px',
    border: 'none',
    outline: 'none',
    borderRadius: '5px',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#858685',
      color: 'white',
    },
  },
  deleteUserModal: {
    background: 'white',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '50px',
  },
  deleteUserModalTitle: {
    fontSize: '20px',
    color: '#576855',
  },
  btnContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});


const PendingUser = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const loading = useSelector(state => state.pendingUser.loading);
  const totalPendingUser = useSelector(
    state => state.pendingUser.totalList
  );
  const pendingUserList = useSelector(
    state => state.pendingUser.pendingUser
  );

  const [deleteUserPopup, setDeleteUserPopup] = useState(false);
  const [deleteSelectedUser, setDeleteSelectedUser] = useState('');
  const [allPendingUser, setAllPendingUser] = useState([]);

  console.log(allPendingUser, 'allPendingUser');


  useEffect(() => {
    if (Object.values(pendingUserList).length) {
      setAllPendingUser(Object.values(pendingUserList));
    }
  }, [pendingUserList]);


  const getPendingUsers = (start, keyword, fromDate, toDate, sortBy, sortType) => {
    const obj = {
      keyword: keyword || '',
      fromDate: fromDate || '',
      toDate: toDate || '',
      sortBy: sortBy || '',
      sortType: sortType || '',
    };
    dispatch(
      pendingUserRequest({
        data: obj,
        start: start || 0,
        limit: 10,
      })
    );
  };

  const handleDeleteUser = id => {
    setDeleteSelectedUser(id);
    setDeleteUserPopup(true);
  };

  const deleteUser = () => {
    dispatch(deleteUserRequest({ data: { id: deleteSelectedUser } }));
    setTimeout(() => {
      getPendingUsers();
      setDeleteUserPopup(false)
    }, 1000);
  };

  const moveUser = (start, id, type, val) => {
    console.log(id, 'moveUser');
    dispatch(moveUserRequest({
      data: {
        userIds: [id],
        status: type,
        fromPending: val,
      }
    }));
    setTimeout(() => {
      getPendingUsers(start);
    }, 999);
  };
  return (
    <Skeleton>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomTable
            tableBodyData={allPendingUser}
            getAllUsers={getPendingUsers}
            type='pending'
            moveUser={moveUser}
            deleteUser={handleDeleteUser}
            totalUser={totalPendingUser}
          />
        </Grid>
      </Grid>
      {deleteUserPopup ? (<div className={classes.deleteModal}>
        <div className={classes.deleteModalChildren}>
          <div className={classes.deleteUserModal}>
            <div className={classes.deleteModalCross} onClick={() => setDeleteUserPopup(false)}><RxCross2 size={30} /></div>
            <h3 className={classes.deleteUserModalTitle}>Are you sure you want to delete this user?</h3>
            <div className={classes.btnContainer}>
              <button className={classes.backBtn} onClick={() => setDeleteUserPopup(false)}>No</button>
              <button className={classes.btn} onClick={deleteUser}>Yes</button>
            </div>
          </div>
        </div>
      </div>)
        :
        null}
      {showLoader(loading, 'transparent')}
    </Skeleton>
  )
}

export default PendingUser
